import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=59738b5c&scoped=true&"
import script from "./SystemMessage.vue?vue&type=script&lang=js&"
export * from "./SystemMessage.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessage.vue?vue&type=style&index=0&id=59738b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59738b5c",
  null
  
)

export default component.exports